import React, { Component } from "react";
import { Div, Image, Text } from "atomize";
// import { Link } from "gatsby";
import Helmet from "react-helmet";

import PrimaryButton from "./PrimaryButton";
import MobileHeaderMenu from "./MobileHeaderMenu";
import DesktopHeaderSubMenu from "./DesktopHeaderSubMenu";
import AnimateLink from "./AnimateLink";
import WebsiteContainer from "./WebsiteContainer";
import CustomContainer from "./CustomContainer";
import { Anchor } from "atomize/dist";
import CssBadge from "./CssBadge";
// import AniLink from "gatsby-plugin-transition-link/AniLink";

const headerLinks = [
  {
    name: "Live Demo",
    link: "/product-tour",
  },
  {
    name: "Solutions",
    link: "",
    submenu: [
      {
        image: "../../images/influencer-marketing-icon.svg",
        title: "Micro Influencer Marketing",
        menu: [
          {
            heading: `Curated Creator Network`,
            paragraph: `Invite-only, professional creators`,
            link: "/curated-creators-network",
          },
          {
            heading: `Generate Brand Buzz`,
            paragraph: `Getting people to talk about your brand`,
            link: "/generate-brand-buzz",
          },
          {
            heading: `Improved Engagement Rates`,
            paragraph: `Drive traffic to your brand`,
            link: "/improved-engagement-rates",
          },
        ],
      },
      {
        image: "../../images/custom-content-icon.svg",
        title: "Custom Content for Increased Performance",
        menu: [
          {
            heading: `Campaign Management Suite`,
            paragraph: `Manage at the office or on the go`,
            link: "/campaign-management-suite",
          },
          {
            heading: `Influencer Generated Content`,
            paragraph: `Influencer-generated content on tap`,
            link: "/influencer-generated-content",
          },
          {
            heading: `Increase Sales`,
            paragraph: `Create content that boosts returns`,
            link: "/increase-sales",
          },
        ],
      },
    ],
  },
  {
    name: "Creators",
    link: "/creators",
  },
  {
    name: "Pricing",
    link: "/pricing",
  },
  {
    name: "Resources",
    link: "",
    submenu: [
      {
        menu: [
          { heading: `Blog`, image: `/images/macbook-2.png`, link: "/blog" },
          {
            heading: `Case Studies`,
            image: `/images/case-study.png`,
            link: "/case-study",
          },
          {
            heading: `DTC Podcast`,
            image: `/images/DTC_Desktop.png`,
            link: "/podcast",
          },
        ],
      },
    ],
  },
];

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileHeaderOpen: false,
      getStarted: false,
      desktopHeaderOpen: null,
    };
  }

  toggleCollapse = value => {
    const { showCollapse } = this.state;

    if (showCollapse === value) {
      this.setState({ showCollapse: false });
    } else {
      this.setState({ showCollapse: value });
    }
  };

  toggleMobileHeader = () => {
    const { mobileHeaderOpen } = this.state;

    this.setState({ mobileHeaderOpen: !mobileHeaderOpen });
  };

  toggleGetStarted = value => {
    const { getStarted } = this.state;

    // this.setState({ getStarted: !getStarted });

    if (getStarted === value) {
      this.setState({ getStarted: false });
    } else {
      this.setState({ getStarted: value });
    }

    // console.log("Get Started");
  };

  toggleDesktopHeader = (submenu, linkName) => {
    const { desktopHeaderOpen } = this.state;
    if (submenu && desktopHeaderOpen === linkName) {
      this.setState({
        desktopHeaderOpen: false,
      });
    } else {
      this.setState({
        desktopHeaderOpen: linkName,
      });
    }
  };

  render() {
    const { data } = this.props;
    const { mobileHeaderOpen } = this.state;
    const { getStarted } = this.state;
    const { headerFixed, brandImage, isTransparent } = this.props;
    const { showCollapse } = this.state;
    const { desktopHeaderOpen } = this.state;

    const content = JSON.parse(data.contentfulJson.json.json);

    return (
      <>
        <Div
          className={
            isTransparent && !desktopHeaderOpen && "transparent-header"
          }
          tag="header"
          pos={headerFixed ? "fixed" : "relative"}
          top="0"
          left="0"
          right="0"
          // zIndex="14"
          textColor="white"
          fontFamily="secondary"
          onMouseLeave={() => this.toggleDesktopHeader(null)}
          // onClick={() => this.toggleDesktopHeader(null)}
        >
          <Div
            className="header-inner-wrapper"
            border={{ b: "1px solid" }}
            borderColor="rgba(255,255,255,0.16)"
            bg="black"
          >
            <Div maxW="1440px" m="0 auto">
              <CustomContainer>
                <Div d="flex" align="center" justify="space-between">
                  <Div
                    d="flex"
                    align="center"
                    p={{ xs: "1.25rem 0", sm: "1.25rem 0" }}
                  >
                    <Image
                      d={{ lg: "none" }}
                      src={
                        mobileHeaderOpen
                          ? "/images/menu-close-image.png"
                          : "/images/menu-icon-image.png"
                      }
                      w="auto"
                      h="1rem"
                      onClick={this.toggleMobileHeader}
                    />
                    <AnimateLink
                      to="/"
                      style={{ display: "inherit" }}
                      onMouseEnter={() => this.toggleDesktopHeader(null)}
                    >
                      <Image
                        src="/images/trend-logo.svg"
                        transform={{
                          xs: "translate(-50%, -50%)",
                          lg: "none",
                        }}
                        w="auto"
                        pos={{ xs: "absolute", lg: "static" }}
                        top="50%"
                        left="50%"
                        h={{ xs: "1rem", lg: "1.1rem" }}
                        //m={{ r: { sm: "2rem" } }}
                      />
                    </AnimateLink>
                    {brandImage && (
                      <>
                        <Text
                          textWeight="bold"
                          fontFamily="secondary"
                          m="0 1rem"
                          d={{ xs: "none", md: "block" }}
                        >
                          +
                        </Text>
                        <AnimateLink
                          to="/"
                          style={{ display: "inherit" }}
                          onMouseEnter={() => this.toggleDesktopHeader(null)}
                        >
                          <Image
                            src={brandImage}
                            transform={{
                              xs: "translateY( -50%)",
                              lg: "none",
                            }}
                            w="auto"
                            pos={{ xs: "absolute", lg: "static" }}
                            top="50%"
                            right="20px"
                            h={{ xs: "1rem", lg: "1.5rem" }}
                            m={{ r: { sm: "2rem" } }}
                          />
                        </AnimateLink>
                      </>
                    )}

                    {/* Desktop Header Menu */}
                    <Div
                      d={{ xs: "none", lg: "flex" }}
                      pos={{ xl: "absolute" }}
                      top="50%"
                      left="50%"
                      transform={{ xl: "translate(-50%, -50%)" }}
                    >
                      {headerLinks.map((link, index) => {
                        if (link.submenu) {
                          return (
                            <Div
                              m={{
                                r: index !== headerLinks.length - 1 && "1.5rem",
                              }}
                              cursor="pointer"
                              transition="default"
                            >
                              <Div
                                d={{
                                  xs: "none",
                                  lg: "none",
                                  xl: "block",
                                }}
                                color="black"
                                onMouseEnter={() =>
                                  this.toggleDesktopHeader(
                                    link.submenu,
                                    link.name
                                  )
                                }
                                className="gatsby-link"
                              >
                                <Div
                                  d="flex"
                                  align="center"
                                  textColor="#6B6B6B"
                                  hoverTextColor="white"
                                  className="link-name"
                                  transition
                                >
                                  <Text textWeight="600">{link.name}</Text>
                                  {link.submenu && (
                                    <Image
                                      m="4px 0 0 0.5rem"
                                      src="/images/downarrow.png"
                                      h="5px"
                                      w="auto"
                                      className="dropdown-arrow"
                                    ></Image>
                                  )}
                                </Div>
                              </Div>

                              <Div
                                d={{
                                  xs: "none",
                                  lg: "block",
                                  xl: "none",
                                }}
                                color="black"
                                onClick={() =>
                                  this.toggleDesktopHeader(
                                    link.submenu,
                                    link.name
                                  )
                                }
                                className="gatsby-link"
                              >
                                <Div
                                  d="flex"
                                  align="center"
                                  textColor="#6B6B6B"
                                  hoverTextColor="white"
                                  className="link-name"
                                  transition
                                >
                                  <Text textWeight="600">{link.name}</Text>
                                  {link.submenu && (
                                    <Image
                                      m="4px 0 0 0.5rem"
                                      src="/images/downarrow.png"
                                      h="5px"
                                      w="auto"
                                      className="dropdown-arrow"
                                    ></Image>
                                  )}
                                </Div>
                              </Div>
                            </Div>
                          );
                        }

                        return (
                          <Div
                            m={{
                              r: index !== headerLinks.length - 1 && "1.5rem",
                            }}
                            onMouseEnter={() => this.toggleDesktopHeader(null)}
                            cursor="pointer"
                            transition="default"
                          >
                            <AnimateLink
                              to={link.link}
                              color="black"
                              activeClassName="active"
                              className="gatsby-link"
                            >
                              <Div
                                d="flex"
                                align="center"
                                textColor="#6B6B6B"
                                hoverTextColor="white"
                                className="link-name"
                                transition
                              >
                                <Text textWeight="600">{link.name}</Text>
                              </Div>
                            </AnimateLink>
                          </Div>
                        );
                      })}
                    </Div>
                  </Div>
                  <Div
                    d={{ xs: "none", lg: "flex" }}
                    align="center"
                    p={{ xs: "0.7rem 0", sm: "0.7rem 0" }}
                    onMouseEnter={() => this.toggleDesktopHeader(null)}
                  >
                    <Anchor href="https://app.trend.io/login">
                      <PrimaryButton
                        className="secondary-btn"
                        bg="black700"
                        hoverBg="black500"
                        borderColor="black500"
                        m={{ r: { xs: "0.5rem", sm: "1rem" } }}
                        textTransform="none"
                      >
                        Sign In
                      </PrimaryButton>
                    </Anchor>
                    <Div
                      pos="relative"
                      d={{ xs: "none", xl: "block" }}
                      onMouseLeave={() => this.toggleGetStarted(null)}
                    >
                      <Div>
                        <PrimaryButton
                          className="primary-btn"
                          bg="primary"
                          hoverBg="primary700"
                          textColor="black"
                          textTransform="none"
                          border="none"
                          onMouseEnter={() => this.toggleGetStarted(true)}
                        >
                          {content.getStarted.label}
                        </PrimaryButton>
                      </Div>
                      <Div
                        pos="absolute"
                        top="100%"
                        left="50%"
                        transform="translateX(-50%)"
                        w="calc(100% + 16px)"
                        p={getStarted ? { t: "1rem" } : "0"}
                        maxH={getStarted ? "1000px" : "0"}
                        opacity={getStarted ? "1" : "0"}
                        overflow="hidden"
                        transition="all 0.2s ease-in-out"
                        zIndex="10"
                      >
                        <Div
                          border={{ t: "3px solid" }}
                          borderColor="primary"
                          pos="relative"
                        >
                          <Div
                            className="get-started-arrow"
                            w="0"
                            h="0"
                            pos="absolute"
                            top="-9px"
                            left="50%"
                            transform="translateX(-50%)"
                          />
                          {content.getStarted.links.map(item => (
                            <AnimateLink
                              to={item.link}
                              // onMouseEnter={() => this.toggleGetStarted()}
                            >
                              <Div
                                p="1.1rem"
                                bg="#1F1F1F"
                                textColor="white"
                                hoverTextColor="primary"
                                textWeight="700"
                                textAlign="center"
                                border={{ b: "1px solid" }}
                                borderColor="black"
                                transition="all 0.2s ease-in-out"
                              >
                                {item.text}
                              </Div>
                            </AnimateLink>
                          ))}
                        </Div>
                      </Div>
                    </Div>
                  </Div>
                </Div>
              </CustomContainer>
            </Div>
          </Div>
          {/* Mobile Header Menu */}
          <MobileHeaderMenu
            mobileHeaderOpen={mobileHeaderOpen}
            toggleCollapse={this.toggleCollapse}
            toggleMobileHeader={this.toggleMobileHeader}
            showCollapse={showCollapse}
            headerLinks={headerLinks}
            getStartedContent={content}
          />
          {headerLinks.map(link => {
            return (
              <Div key={link.name}>
                {link.submenu && (
                  <DesktopHeaderSubMenu
                    desktopHeaderOpen={desktopHeaderOpen}
                    menu={link.submenu}
                    linkName={link.name}
                  />
                )}
              </Div>
            );
          })}
        </Div>
        {/* {headerFixed && !isTransparent && (
          <Div h={{ xs: "57px", lg: "81px" }}></Div>
        )} */}
        {/* <CssBadge /> */}
      </>
    );
  }
}

export default Header;
